import { render, staticRenderFns } from "./aktuellesReadingView.vue?vue&type=template&id=69347235&scoped=true"
import script from "./aktuellesReadingView.vue?vue&type=script&lang=js"
export * from "./aktuellesReadingView.vue?vue&type=script&lang=js"
import style0 from "./aktuellesReadingView.vue?vue&type=style&index=0&id=69347235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69347235",
  null
  
)

export default component.exports